import { PartnersNumber } from "@entity/domain/models/partners-number/partners-number.model";

export class CreatePartnersNumber {
    constructor(
        public numberOfMembers: PartnersNumber["numberOfMembers"],
        public registeredCcaa: PartnersNumber["registeredCcaa"],
        public entity: PartnersNumber["entity"],
    ) {}
}
